import { createApiClient, createPublicApiClient } from './client'
import { ApiResponse } from './types'

export interface WaypointSharePreview {
  token: string
  ownerDisplayName: string
  expiresAt: string | null
  waypoint: {
    id: string
    name: string
    latitude: number | null
    longitude: number | null
    notes: string | null
    poi_type: string | null
    poi_custom_label: string | null
    poi_address: string | null
    created_at: string
  }
}

export interface AcceptWaypointShareResponse {
  waypointId: string
}

/**
 * Client for the onX-style waypoint share flow. Preview is public; accepting a
 * waypoint into "My Content" requires auth.
 */
export class WaypointSharesApi {
  private apiClient
  private publicApiClient

  constructor(getAuthToken: () => Promise<string | null>) {
    this.apiClient = createApiClient(getAuthToken)
    this.publicApiClient = createPublicApiClient()
  }

  async getPreview(token: string): Promise<WaypointSharePreview> {
    const response = await this.publicApiClient.get<ApiResponse<WaypointSharePreview>>(
      `/itinerary/share/${token}`
    )
    return response.data
  }

  async accept(token: string): Promise<AcceptWaypointShareResponse> {
    const response = await this.apiClient.post<ApiResponse<AcceptWaypointShareResponse>>(
      `/itinerary/share/accept`,
      { token }
    )
    return response.data
  }
}
